import React from "react";

const EmptyButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <circle cx="9" cy="9" r="8.5" stroke="#DDE2EB" />
    </svg>
  );
};

export default EmptyButton;
